module.exports = __webpack_public_path__ + "assets/media/microsoft-logo.704fac3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/SignupChoiceCard/microsoft-logo.svg
// module id = 3044
// module chunks = 0